module.exports = __webpack_public_path__ + "1d791f5bb0aa23fd0f88e05ec97efb43.png";